import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { publicOperationMiddleware } from '../../../permissions/middlewares/publicOperationMiddleware.js';
import { throttleMiddleware } from '../../../request-middlewares/throttelMiddleware.js';
import { resolveSendSuSInitalSchoolSelectedMail } from '../server/resolveSendSuSInitalSchoolSelectedMail.js';

@Entity()
export class SuSInitalRegistrationData extends AdornisEntity {
  static override _class = 'SuSInitalRegistrationData';

  @Field(type => String)
  email!: string;

  @Field(type => String)
  schoolID!: string;

  @Field(type => String)
  klasse!: string;

  @Field(type => String)
  childID: Maybe<string>;

  @Field(type => String)
  origin!: string;
}

export const sendSuSInitalSchoolSelectedMail = registerMutation({
  operationName: 'sendSuSInitalSchoolSelectedMail',
  type: () => String,
  params: [
    {
      type: () => SuSInitalRegistrationData,
      name: 'data',
    },
  ],
  middlewares: [
    publicOperationMiddleware('Oeffentliches SuS-Anmeldeformular: Start der Bewerbung ohne Account'),
    throttleMiddleware(5000),
  ],
  resolve: resolveSendSuSInitalSchoolSelectedMail,
});
